<div class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100" *transloco="let t; read: 'auth.invitation'">
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />
  <div class="flex flex-col items-center justify-center gap-1.5">
    <h2 class="text-primary">{{ isOwnerInvitation ? t('ownerTitle') : t('title') }}</h2>
    @if (email) {
      <p class="text-large-bold">{{ email }}</p>
    }
  </div>
  <div class="relative z-10 min-h-[422px] w-[640px] rounded-[5px] bg-white p-8">
    @if (invitationState === 'valid') {
      <form
        [formGroup]="acceptInvitationForm"
        (ngSubmit)="onSubmit()"
        [ngClass]="{ 'blur-md': isLoading }"
        class="flex h-full flex-col justify-between gap-4"
      >
      <div>
        <div class="mb-6">
          <app-form-element [label]="t('form.password.label')" [labelFor]="'password'" [showRequiredAsterisk]="false">
            <input
              appTogglePassword
              class="form-control"
              id="password"
              type="password"
              [placeholder]="t('form.password.placeholder')"
              formControlName="password"
            />
          </app-form-element>
        </div>

        <div>
          <app-form-element
            [label]="t('form.confirmPassword.label')"
            [labelFor]="'confirmPassword'"
            [validationMessages]="{ passwordMismatch: t('passwordMismatch') }"
            [showRequiredAsterisk]="false"
          >
            <input
              appTogglePassword
              class="form-control"
              id="confirmPassword"
              type="password"
              [placeholder]="t('form.confirmPassword.placeholder')"
              formControlName="confirmPassword"
              (focus)="onConfirmPasswordFocus()"
            />
          </app-form-element>
        </div>
      </div>
      @if (acceptInvitationForm.get('password')?.value) {
        <app-password-strength
          [password]="acceptInvitationForm.get('password')?.value"
          [showText]="true"
          [showIndicator]="true"
        ></app-password-strength>
      }

      <p class="text-medium-regular text-gray-600">{{ (passwordPolicy | passwordRequirementsText) || t('passwordRequirements') }}</p>
      <div>
        <button type="submit" [disabled]="isLoading || acceptInvitationForm.invalid" class="btn btn-primary w-full justify-center">
          {{ t('button.acceptInvitation') }}
        </button>
      </div>
      </form>
    } @else {
      <!-- Show invitation state message -->
      <div class="flex h-full flex-col items-center justify-center gap-6 text-center">
        <div class="flex flex-col gap-2">
          @switch (invitationState) {
            @case ('expired') {
              <h3 class="text-xl font-semibold text-red-600">{{ t('stateMessages.expired.title') }}</h3>
              <p class="text-gray-600">{{ t('stateMessages.expired.description') }}</p>
            }
            @case ('alreadyUsed') {
              <h3 class="text-xl font-semibold text-orange-600">{{ t('stateMessages.alreadyUsed.title') }}</h3>
              <p class="text-gray-600">{{ t('stateMessages.alreadyUsed.description') }}</p>
            }
            @case ('withdrawn') {
              <h3 class="text-xl font-semibold text-red-600">{{ t('stateMessages.withdrawn.title') }}</h3>
              <p class="text-gray-600">{{ t('stateMessages.withdrawn.description') }}</p>
            }
            @case ('inactive') {
              <h3 class="text-xl font-semibold text-gray-600">{{ t('stateMessages.inactive.title') }}</h3>
              <p class="text-gray-600">{{ t('stateMessages.inactive.description') }}</p>
            }
            @case ('notFound') {
              <h3 class="text-xl font-semibold text-red-600">{{ t('stateMessages.notFound.title') }}</h3>
              <p class="text-gray-600">{{ t('stateMessages.notFound.description') }}</p>
            }
          }
        </div>
        <div class="text-sm text-gray-500">
          <a routerLink="/auth/login" class="text-primary hover:underline">
            {{ t('stateMessages.backToLogin') }}
          </a>
        </div>
      </div>
    }
    @if (isLoading) {
      <div class="absolute top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
        <app-loader color="blue"></app-loader>
      </div>
    }
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
